import { render, staticRenderFns } from "./AttributesListRelatedTabs.vue?vue&type=template&id=4982229b"
import script from "./AttributesListRelatedTabs.vue?vue&type=script&lang=js"
export * from "./AttributesListRelatedTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports